import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { AddJobRequirement, doctorAllDoctorProfile, getSpecializationList, } from "../../hooks/services/api-services";
import { decryptAEStoJSON, toastEmitter } from "../../utils/utilities";
import { API_RESPONSE } from "../../utils/app-constants";
import { ROUTES } from "../../hooks/routes/routes-constant";
import { NoLeadingSpaceRegex } from "../../utils/regexValidation";
import BreadCrum from "../../components/common/BreadCrum";
import Input from "../../components/common/input";
import DropDown from "../../components/common/dropdown";
import { handleFormInput } from "../../utils/form-utils";
import TextArea from "../../components/common/text-area";
import Button from "../../components/common/button";
import { useTranslation } from "react-i18next";
import Modal from "../../components/common/Model";
import { RIGHTARROW_IMG } from "../../utils/aap-image-constant";
import Calendar from "react-calendar";
import dayjs from "dayjs";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";


const AddPosting = () => {
  dayjs.extend(isSameOrAfter);
  dayjs.extend(isSameOrBefore);
  const { t, i18n } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const { value } = useSelector((state) => state?.loggedUser);
  const userData = decryptAEStoJSON(value);
  const [specializationList, setSpecializationList] = useState([]);
  const [selectedOtherProfile, setSelectedOtherProfile] = useState(false);
  const [selectedOtherSpecialty, setSelectedOtherSpecialty] = useState(false);
  const [showCalendar, setShowCalendar] = useState(false);

  const [payload, setPayload] = useState({
    id: 0,
    clinicId: userData?.id,
    title: "",
    description: "",
    country: userData?.country,
    city: userData?.city,
    location: userData?.address,
    durationFromDate: "",
    durationToDate: "",
    specialty: "",
    type: "",
    experience: "",
    profile: "",
    languageType: i18n.language,
    contractType: "",
    lookingFor: "",
    availabilityPeriod: [],   // <-- array
    slotType: "",
    availabilityType: "",

  });
  console.log("payload", payload)
  const [profilelist, setProfileList] = useState([]);
  const addbuttonClick = useRef();
  useEffect(() => {
    getDoctorProfileList(i18n.language);
    fetchSpecializations(i18n.language); // Fetch specializations when language changes
  }, [i18n.language]);

  const navigate = useNavigate();
  const handleDataBack = () => {
    setPayload({
      id: 0,
      clinicId: 0,
      title: "",
      city: "",
      description: "",
      country: "",
      location: "",
      durationFromDate: "",
      durationToDate: "",
      specialty: "",
      type: "",
      contractType: "",
      lookingFor: "",
      availabilityPeriod: [],
      slotType: "",
      availabilityType: "",
    });
    navigate(ROUTES.JOBPOTSLIST);
  };

  const fetchSpecializations = async (language) => {
    try {
      const response = await getSpecializationList(language);
      if (response?.data?.status === 200) {
        const formattedList = response?.data?.data?.map((item) => ({
          value: item?.specializationName,
          label: item?.specializationName,
        }))
          .sort((a, b) => a.label.localeCompare(b.label));

        setSpecializationList(formattedList);
      } else {
        // toastEmitter("error", "Failed to fetch specializations");
      }
    } catch (error) {
      // toastEmitter("error", API_RESPONSE?.MESSAGE_503);
    }
  };

  const getDoctorProfileList = async (language) => {
    try {
      const response = await doctorAllDoctorProfile(language);
      if (response?.data?.status === 200) {
        const formattedListdata = response?.data?.data?.map((item) => ({
          label: item,
          value: item,
        }))
          .sort((a, b) => a.label.localeCompare(b.label));

        setProfileList(formattedListdata);
      } else {
        // toastEmitter("error", "Failed to fetch Profile List");
      }
    } catch (error) {
      // toastEmitter("error", API_RESPONSE?.MESSAGE_503);
    }
  };

  const handleSubmit = (e) => {
    console.log("Form payload:", payload);
    console.log("Selected Specialization:", payload?.specialty);
    console.log("Selected Profile:", payload?.profile);
    e.preventDefault();

    if (
      !NoLeadingSpaceRegex.test(payload?.title) ||
      payload?.title?.trim() === ""
    ) {
      return toastEmitter(
        "error",
        "Please enter a valid title (No leading spaces, cannot be empty)."
      );
    }

    if (payload?.durationFromDate?.trim() === "") {
      return toastEmitter("error", "Requirement Start Date is mandatory!");
    }
    if (payload?.durationToDate?.trim() === "") {
      return toastEmitter("error", "Requirement End Date is mandatory!");
    }
    if (payload?.country?.trim() === "") {
      return toastEmitter("error", "Country is mandatory!");
    }
    if (payload?.city?.trim() === "") {
      return toastEmitter("error", "city is mandatory!");
    }
    if (payload?.contractType?.trim() === "") {
      return toastEmitter("error", "Contract type is mandatory!");
    }
    if (payload?.lookingFor?.trim() === "") {
      return toastEmitter("error", "Job type is mandatory!");
    }
    if (payload?.specialty?.trim() === "") {
      return toastEmitter("error", "Specialization is mandatory!");
    }
    if (payload?.otherSpecialty?.trim() === "") {
      return toastEmitter("error", "Enter Your Specialization");
    }
    if (payload?.otherProfile?.trim() === "") {
      return toastEmitter("error", "Enter Your Profile");
    }
    if (payload?.profile?.trim() === "") {
      return toastEmitter("error", "Profile is mandatory!");
    }

    if (
      !NoLeadingSpaceRegex.test(payload?.experience) ||
      payload?.experience?.trim() === ""
    ) {
      return toastEmitter(
        "error",
        "Please enter a valid experience (No leading spaces, cannot be empty)."
      );
    }

    if (
      !NoLeadingSpaceRegex.test(payload?.location) ||
      payload?.location?.trim() === ""
    ) {
      return toastEmitter(
        "error",
        "Please enter a valid location (No leading spaces, cannot be empty)."
      );
    }

    if (
      !NoLeadingSpaceRegex.test(payload?.description) ||
      payload?.description?.trim() === ""
    ) {
      return toastEmitter(
        "error",
        "Please enter a valid description (No leading spaces, cannot be empty)."
      );
    }
    setIsLoading(true);

    AddJobRequirement(payload)
      .then(function (response) {
        if (response.data?.status !== 200) {
          toastEmitter("error", response?.data?.message);
        }
        if (response.data?.status === 200) {
          // toastEmitter("success", response?.data?.message);
          setPayload({
            id: 0,
            clinicId: userData?.id,
            city: userData?.city,
            title: "",
            description: "",
            country: "",
            location: "",
            durationFromDate: "",
            durationToDate: "",
            specialty: "",
            type: "",
            experience: "",
            profile: "",
            languageType: i18n.language,
            contractType: "",
            lookingFor: "",
            availabilityPeriod: [],
            slotType: "",
            availabilityType: "",

          });
          addbuttonClick.current.click();
          navigate(ROUTES.JOBPOTSLIST);
        }
        return setIsLoading(false);
      })
      .catch(function (err) {
        toastEmitter("error", API_RESPONSE?.MESSAGE_503);
        return setIsLoading(false);
      });
  };
  const todayDate = new Date().toISOString().split("T")[0]; // 'yyyy-MM-dd'
  return (
    <div className="main_datatable my-lg-3 mt-1 ">
      <form onSubmit={handleSubmit}>
        <div className=" add_doctor card p-3 border border-radius_input mb-3">
          <BreadCrum
            firstData={t("My Requiremnet List")}
            iconshow1={true}
            secondData={t("Add Requirement")}
            onFirstDataClick={handleDataBack}
          />
          <div className="row">
             <div className="col-md-6 mb-2">
              <Input
                className="border-radius_input"
                type="date"
                min={todayDate}
                value={payload?.durationFromDate}
                name="durationFromDate"
                placeHolder="Job post date"
                handleChange={(e) => setPayload(handleFormInput(e, payload))}
                labelName="Job Post Date"
              />
            </div>
            <div className="col-md-6 mb-2">
              <Input
                className="border-radius_input"
                type="date"
                value={payload?.durationToDate}
                min={payload?.durationFromDate || todayDate}
                name="durationToDate"
                placeHolder="Requirement expire date"
                handleChange={(e) => setPayload(handleFormInput(e, payload))}
                labelName="Job Expire Date"
              />
            </div>
            <div className="col-md-6 mb-2">
              <Input
                className="border-radius_input"
                type="text"
                value={payload?.title}
                name="title"
                placeHolder="Enter title"
                handleChange={(e) => setPayload(handleFormInput(e, payload))}
                labelName="Title"
              />
            </div>
            <div className="col-md-6 mb-2">
              <Input
                className="border-radius_input"
                type="text"
                value={payload?.country}
                name="country"
                placeHolder="Enter country"
                // handleChange={(e) => setPayload(handleFormInput(e, payload))}
                labelName="Country"
                disabled={true}
              />
            </div>
            <div className="col-md-6 mb-2">
              <Input
                className="border-radius_input"
                type="text"
                value={payload?.city}
                name="City"
                placeHolder="Enter City"
                labelName={t("city")}
                disabled={true}
              />
            </div>
           
            <div className="col-md-6 mb-2">
              <Input
                type="number"
                className="border-radius_input"
                value={payload?.experience}
                name="experience"
                placeHolder="Experience"
                handleChange={(e) => setPayload(handleFormInput(e, payload))}
                labelName="Experience"
                onKeyDown={(e) => {
                  if (
                    ["e", "E", "+", "-", "ArrowUp", "ArrowDown"].includes(e.key)
                  ) {
                    e.preventDefault();
                  }
                }}
                onWheel={(e) => e.target.blur()}
              />
            </div>
            {/* <div className="col-md-6 mb-2">
              <DropDown
                labelName={t("typeOfContract")}
                className="border-radius_input"
                name="contractType"
                options={[
                  { label: "Full Time", value: "Full Time" },
                  { label: "Part Time", value: "Part Time" },
                  { label: "Freelance", value: "Freelance" },
                  { label: "On Call", value: "On Call" },
                ]}
                value={payload.contractType}
                handleSelect={(e) =>
                  setPayload({ ...payload, contractType: e.target.value })
                }
              />
            </div> */}

            {/* <div className="col-md-6 mb-2">
              <DropDown
                labelName={t("typeOfJob")}
                className="border-radius_input"
                name="lookingFor"
                options={[
                  { label: "Short Term Job", value: "Short Term Job" },
                  { label: "Fixed Job", value: "Fixed Job" },
                ]}
                value={payload.lookingFor}
                handleSelect={(e) =>
                  setPayload({ ...payload, lookingFor: e.target.value })
                }
              />
            </div> */}

            {/* <div className="col-md-6 mb-2">
              <Input
                className="border-radius_input"
                value={payload.availabilityPeriod}
                name="availabilityPeriod"
                placeHolder="Availability Period"
                handleChange={(e) => setPayload(handleFormInput(e, payload))}
                labelName="Availability Period"
                type="date"
                min={todayDate}
              />
            </div> */}


            {/* <div className="col-md-6 mb-2">
              <DropDown
                labelName="Select Type"
                name="type"
                options={typeOptions}
                value={payload?.type}
                handleSelect={handleSelectType}
                showastrict={true}
                className="border-radius_input"
              />
            </div> */}




            {/* <div className="col-md-6 mt-3">
                <div className="card">
                  <Calendar
                    minDate={new Date()}
                    locale={i18n.language}
                    selectRange={payload.availabilityType === "RANGE"} // ✅ only enable range selection in RANGE mode
                    value={
                      payload.availabilityType === "RANGE" && payload.availabilityPeriod.length === 2
                        ? [
                          new Date(payload.availabilityPeriod[0]),
                          new Date(payload.availabilityPeriod[1]),
                        ]
                        : payload.availabilityType === "DATES" && payload.availabilityPeriod.length > 0
                          ? payload.availabilityPeriod.map((d) => new Date(d))
                          : null
                    }
                    onClickDay={(date) => {
                      const formattedDate = dayjs(date).format("YYYY-MM-DD");

                      // ✅ Toggle for DATES
                      if (payload.availabilityType === "DATES") {
                        let updatedDates = [...payload.availabilityPeriod];
                        if (updatedDates.includes(formattedDate)) {
                          updatedDates = updatedDates.filter((d) => d !== formattedDate);
                        } else {
                          updatedDates.push(formattedDate);
                        }
                        setPayload({ ...payload, availabilityPeriod: updatedDates });
                      }
                    }}
                    onChange={(value) => {
                      // ✅ Capture RANGE
                      if (payload.availabilityType === "RANGE" && Array.isArray(value)) {
                        const [start, end] = value;
                        if (start && end) {
                          setPayload({
                            ...payload,
                            availabilityPeriod: [
                              dayjs(start).format("YYYY-MM-DD"),
                              dayjs(end).format("YYYY-MM-DD"),
                            ],
                          });
                        }
                      }
                    }}
                    tileClassName={({ date }) => {
                      const formattedDate = dayjs(date).format("YYYY-MM-DD");

                      // ✅ Highlight DATES
                      if (
                        payload.availabilityType === "DATES" &&
                        payload.availabilityPeriod.includes(formattedDate)
                      ) {
                        return "custom-multiple-date";
                      }

                      // ✅ Highlight RANGE
                      if (
                        payload.availabilityType === "RANGE" &&
                        payload.availabilityPeriod.length === 2
                      ) {
                        const [start, end] = payload.availabilityPeriod;
                        if (
                          dayjs(formattedDate).isSameOrAfter(dayjs(start)) &&
                          dayjs(formattedDate).isSameOrBefore(dayjs(end))
                        ) {
                          return "custom-range-date";
                        }
                      }

                      return null;
                    }}
                    className="w-100 border-0"
                  />
                </div>
              </div> */}


            <div className="col-md-6 mb-2 position-relative">
              <DropDown
                labelName="Availability Type"
                className="border-radius_input"
                name="availabilityType"
                options={[
                  { label: "Date", value: "DATES" },
                  { label: "Range", value: "RANGE" },
                ]}
                value={payload.availabilityType}
                handleSelect={(e) => {
                  setPayload({
                    ...payload,
                    availabilityType: e.target.value,
                    availabilityPeriod: [],
                  });
                  setShowCalendar(true); // dropdown select hone par calendar dikhao
                }}
                showastrict={true}
              />

              {/* 👇 Agar calendar close hai to reopen button dikhana */}
              {payload.availabilityType && !showCalendar && (
                <button
                  type="button"
                  className="btn btn-outline-primary mt-2 p-1"
                  onClick={() => setShowCalendar(true)}
                >
                  Show Dates
                </button>
              )}

              {showCalendar && (
                <div className="col-md-6 mt-2 calendar-popup card p-2" style={{
                  position: "absolute",
                  top: "100%", // dropdown ke niche open hoga
                  left: 0,
                  zIndex: 9999,
                  background: "#fff",
                  boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
                }}>
                  {/* Close Icon */}
                  <span
                    style={{
                      position: "absolute",
                      right: "8px",
                      top: "2px",
                      cursor: "pointer",
                      fontSize: "18px",
                      fontWeight: "bold",
                      color: "#666",
                    }}
                    onClick={() => setShowCalendar(false)}
                  >
                    ✕
                  </span>
                  <Calendar
                    minDate={new Date()}
                    locale={i18n.language}
                    selectRange={payload.availabilityType === "RANGE"}
                    value={
                      payload.availabilityType === "RANGE" &&
                        payload.availabilityPeriod.length === 2
                        ? [
                          new Date(payload.availabilityPeriod[0]),
                          new Date(payload.availabilityPeriod[1]),
                        ]
                        : payload.availabilityType === "DATES"
                          ? null // DATES me ham value pass nahi karenge (warna misbehave karta hai)
                          : null
                    }
                    onClickDay={(date) => {
                      const formattedDate = dayjs(date).format("YYYY-MM-DD");

                      if (payload.availabilityType === "DATES") {
                        let updatedDates = [...payload.availabilityPeriod];
                        if (updatedDates.includes(formattedDate)) {
                          updatedDates = updatedDates.filter((d) => d !== formattedDate);
                        } else {
                          updatedDates.push(formattedDate);
                        }
                        setPayload({ ...payload, availabilityPeriod: updatedDates });
                      }
                    }}
                    onChange={(value) => {
                      if (payload.availabilityType === "RANGE" && Array.isArray(value)) {
                        const [start, end] = value;
                        if (start && end) {
                          setPayload({
                            ...payload,
                            availabilityPeriod: [
                              dayjs(start).format("YYYY-MM-DD"),
                              dayjs(end).format("YYYY-MM-DD"),
                            ],
                          });
                        }
                      }
                    }}
                    tileClassName={({ date }) => {
                      const formattedDate = dayjs(date).format("YYYY-MM-DD");

                      // DATES (multiple selection)
                      if (
                        payload.availabilityType === "DATES" &&
                        payload.availabilityPeriod.includes(formattedDate)
                      ) {
                        return "custom-multiple-date";
                      }

                      // RANGE (continuous selection)
                      if (
                        payload.availabilityType === "RANGE" &&
                        payload.availabilityPeriod.length === 2
                      ) {
                        const [start, end] = payload.availabilityPeriod;
                        if (
                          dayjs(formattedDate).isSameOrAfter(dayjs(start)) &&
                          dayjs(formattedDate).isSameOrBefore(dayjs(end))
                        ) {
                          return "custom-range-date";
                        }
                      }
                      return null;
                    }}
                    className="w-100 border-0"
                  />

                </div>
              )}
            </div>

            <div className="col-md-6 mb-2">

              <DropDown
                labelName="Slot Type"
                className="border-radius_input"
                name="slotType"
                options={[
                  { label: "Half Day", value: "Half Day" },
                  { label: "Full Day", value: "Full Day" },
                ]}
                value={payload.slotType}
                handleSelect={(e) =>
                  setPayload({ ...payload, slotType: e.target.value })
                }
              />
            </div>
            <div className="col-md-6 mb-2">

              <DropDown
                labelName={t("typeOfJob")}
                className="border-radius_input"
                name="lookingFor"
                options={[
                  { label: "Short Term Job", value: "Short Term Job" },
                  { label: "Fixed Job", value: "Fixed Job" },
                ]}
                value={payload.lookingFor}
                handleSelect={(e) =>
                  setPayload({ ...payload, lookingFor: e.target.value })
                }
              />
            </div>
            <div className="col-md-6 mb-2">

              <DropDown
                labelName={t("typeOfContract")}
                className="border-radius_input"
                name="contractType"
                options={[
                  { label: "Full Time", value: "Full Time" },
                  { label: "Part Time", value: "Part Time" },
                  { label: "Freelance", value: "Freelance" },
                  { label: "On Call", value: "On Call" },
                ]}
                value={payload.contractType}
                handleSelect={(e) =>
                  setPayload({ ...payload, contractType: e.target.value })
                }
              />
            </div>

            <div className="col-md-6 mb-2">
              <DropDown
                labelName="Select Specialization"
                className="border-radius_input"
                name="specialty"
                options={[...specializationList, { label: "Other", value: "other" }]}
                value={selectedOtherSpecialty ? "other" : payload.specialty}
                handleSelect={(e) => {
                  const value = e.target.value;
                  if (value === "other") {
                    setSelectedOtherSpecialty(true);
                    setPayload({ ...payload, specialty: "" });
                  } else {
                    setSelectedOtherSpecialty(false);
                    setPayload({ ...payload, specialty: value });
                  }
                }}
                showastrict={true}
              />

            </div>

            {/* Show input box only if specialty is not from the predefined list */}
            {selectedOtherSpecialty && (
              <div className="col-md-6 mb-2">
                <Input
                  type="text"
                  className="form-control border-radius_input"
                  placeholder="Your Specialization"
                  labelName="Enter Your Specialization"
                  name="specialty"
                  value={payload?.specialty || ""}
                  onChange={(e) =>
                    setPayload({ ...payload, specialty: e.target.value })
                  }
                  showastrict={true}
                />
              </div>
            )}


            <div className="col-md-6 mb-2">
              <DropDown
                labelName="Profile"
                className="border-radius_input"
                name="profile"
                options={[...profilelist, { label: "Other", value: "other" }]}
                value={selectedOtherProfile ? "other" : payload.profile}
                handleSelect={(e) => {
                  const value = e.target.value;
                  if (value === "other") {
                    setSelectedOtherProfile(true);
                    setPayload({ ...payload, profile: "" });
                  } else {
                    setSelectedOtherProfile(false);
                    setPayload({ ...payload, profile: value });
                  }
                }}
                showastrict={true}
              />

            </div>

            {selectedOtherProfile && (
              <div className="col-md-6 mb-2">
                <Input
                  type="text"
                  className="form-control border-radius_input"
                  placeholder="Enter Your Profile"
                  labelName="Your Profile"
                  name="profile"
                  value={payload?.profile || ""}
                  onChange={(e) =>
                    setPayload({ ...payload, profile: e.target.value })
                  }
                  showastrict={true}
                />
              </div>
            )}
            {/* 
            <div className="col-md-6 mb-2">
              <DropDown
                labelName="Specialization"
                className="border-radius_input"
                name="specialty"
                options={specializationList}
                value={payload?.specialty}
                handleSelect={(e) =>
                  setPayload({ ...payload, specialty: e.target.value })
                }
                showastrict={true}
              />
            </div> */}

            {/* <div className="col-md-6 mb-2">
              <DropDown
                labelName="Profile"
                className="border-radius_input"
                name="profile"
                options={profilelist}
                value={payload?.profile}
                handleSelect={handleSelectProfile}
                showastrict={true}
              />
            </div> */}


            <div className="col-md-12">
              <Input
                className="border-radius_input"
                type="text"
                value={payload?.location}
                name="location"
                placeHolder="Enter area / location of hospital"
                // handleChange={(e) => setPayload(handleFormInput(e, payload))}
                labelName="Full Address"
                disabled={true}
              />
            </div>
            <div className="col-md-12 ">
              <TextArea
                className="border-radius_input"
                labelName={t("Brief Description")}
                placeholder={t("Enter description")}
                name="description"
                handleChange={(e) => setPayload(handleFormInput(e, payload))}
                value={payload?.description}
                showastrict={true}
              />
            </div>
          </div>
        </div>

        <div className="d-flex flex-wrap  justify-content-center ">
          <Button
            type="button"
            className={`px-5 py-2 rounded border-0  cancelbtn  mb-2 ${i18n.language === "ar" ? "ms-2" : "me-2"}`}
            label="Cancel"
            onClick={handleDataBack}
          />

          <Button
            type="submit"
            className="px-4 py-2 rounded border-0 text-white submitbtn mb-2"
            label="Add Requirement"
            isLoading={isLoading}
          />
        </div>
      </form>
      <Modal
        modalId="addposting"
        heading="Requirement added sucessfully"
        modalClick={addbuttonClick}
        iconsrc={RIGHTARROW_IMG}
        paragraph="Your requirement has been sucessfully added"
      />
    </div>
  );
};

export default AddPosting;
